/* eslint-disable max-len */
export const UPLOAD_FILE_REPORT = "UPLOAD_FILE_REPORT";
export const UPLOAD_FILE_REPORT_SUCCESS = "UPLOAD_FILE_REPORT_SUCCESS";
export const UPLOAD_FILE_REPORT_ERROR = "UPLOAD_FILE_REPORT_ERROR";

export const uploadFileReport = payload => ({ type: UPLOAD_FILE_REPORT, payload });
export const uploadFileReportSuccess = payload => ({ type: UPLOAD_FILE_REPORT_SUCCESS, payload });
export const uploadFileReportError = payload => ({ type: UPLOAD_FILE_REPORT_ERROR, payload });

export const CREATE_REPORT_V2 = "CREATE_REPORT_V2";
export const CREATE_REPORT_V2_SUCCESS = "CREATE_REPORT_V2_SUCCESS";
export const CREATE_REPORT_V2_ERROR = "CREATE_REPORT_V2_ERROR";

export const createReportV2 = payload => ({ type: CREATE_REPORT_V2, payload });
export const createReportV2Success = payload => ({ type: CREATE_REPORT_V2_SUCCESS, payload });
export const createReportV2Error = payload => ({ type: CREATE_REPORT_V2_ERROR, payload });
